import { Flag, type LucideIcon } from 'lucide-react';

export type StakeholderStatus =
  | 'pursue'
  | 'more_info'
  | 'hold'
  | 'pre_service'
  | 'active_service';

export interface StatusOption {
  value: StakeholderStatus;
  label: string;
  /** Default Badge variant used when chip/cell is active and no override */
  variant: 'default' | 'secondary' | 'outline';
  icon?: LucideIcon;
  /** Override Badge className when chip/cell is active */
  activeClassName?: string;
}

/**
 * Status options in workflow order.
 * pre_service + active_service have Flag icon + custom colors.
 * active_service triggers auto-create project in Session B (deferred).
 */
export const STATUS_OPTIONS: readonly StatusOption[] = [
  { value: 'pursue', label: 'Pursue', variant: 'default' },
  { value: 'more_info', label: 'More Info', variant: 'secondary' },
  { value: 'hold', label: 'Hold', variant: 'outline' },
  {
    value: 'pre_service',
    label: 'Pre Service',
    variant: 'default',
    icon: Flag,
    activeClassName: 'bg-blue-700 hover:bg-blue-800 text-white border-transparent',
  },
  {
    value: 'active_service',
    label: 'Active Service',
    variant: 'default',
    icon: Flag,
    activeClassName: 'bg-orange-600 hover:bg-orange-700 text-white border-transparent',
  },
] as const;

/** O(1) lookup by status value */
export const STATUS_CONFIG: Record<StakeholderStatus, StatusOption> =
  STATUS_OPTIONS.reduce((acc, option) => {
    acc[option.value] = option;
    return acc;
  }, {} as Record<StakeholderStatus, StatusOption>);

/** Fallback when status is null/empty (mirror existing behavior) */
export const DEFAULT_STATUS: StakeholderStatus = 'hold';
